import Wait from "./Wait.js";
import { getRandomNormal } from "../../assets/virtual-flyout/math-calc.js";
import { getAirportOpenTime, SCHEDULE_TYPES } from "../../assets/virtual-flyout/airport-service.js";

const WAIT_MINUTES_MIN = 0;
const WAIT_MINUTES_MAX = 90;
const WAIT_MINUTES_MEAN = 30;
const WAIT_MINUTES_STD_DEV = 15;

export default class WaitFuelDelivery extends Wait {
    constructor(planeId, airport) {
        super(planeId, null, 'fuel delivery');
        this.airport = airport;
        this.waitMinutes = Math.round(getRandomNormal(WAIT_MINUTES_MEAN, WAIT_MINUTES_STD_DEV, WAIT_MINUTES_MIN, WAIT_MINUTES_MAX));
    }

    execute() {
        const simState = this.getSimState();
        const airportOpenTime = getAirportOpenTime(this.airport.code, SCHEDULE_TYPES.FUEL, simState.time);
        if (airportOpenTime) {
            this.time = new Date(simState.time + this.waitMinutes * 60000);
            super.execute();
        }
    }
    
}